// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WeiboSquareOutlinedSvg from "@ant-design/icons-svg/es/asn/WeiboSquareOutlined";
import AntdIcon from '../components/AntdIcon';

var WeiboSquareOutlined = function WeiboSquareOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: WeiboSquareOutlinedSvg
  }));
};

WeiboSquareOutlined.displayName = 'WeiboSquareOutlined';
export default React.forwardRef(WeiboSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/WeiboSquareOutlined.js
// module id = 2063
// module chunks = 0